import { DefaultTheme, FlattenInterpolation, ThemeProps, css } from 'styled-components';

const mediaHover = (cssTemplate: FlattenInterpolation<ThemeProps<DefaultTheme>>) => css`
  @media (hover: hover) {
    &:hover {
      ${cssTemplate}
    }
  }
`;

export { mediaHover };
